import { Box, Dialog, Typography } from '@myn/mui';

type WithdrawModalProps = {
  onClose: () => void;
  onSubmit: () => void;
  isDeleting: boolean;
};

const WithdrawModal: React.FC<WithdrawModalProps> = ({
  onClose,
  onSubmit,
  isDeleting,
}: WithdrawModalProps) => {
  const handleReject = () => {
    onSubmit();
    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
      title="Withdraw approval request"
      submitButtonProps={{
        label: 'Yes, delete',
        onClick: handleReject,
        color: 'error',
        disabled: isDeleting,
        startIcon: 'Delete',
      }}
      cancelButtonProps={{
        onClick: onClose,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Typography variant="bodyShort01" color="text.secondary">
          Are you sure you want to delete this approval request?
        </Typography>
      </Box>
    </Dialog>
  );
};

export default WithdrawModal;
